import { render } from "./PlaqueTermsOfUseText.vue?vue&type=template&id=51307a3f"
const script = {}

import "./PlaqueTermsOfUseText.vue?vue&type=style&index=0&id=51307a3f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__